// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__23GGr","disabled":"FileBtn_disabled__1yBtH","warn":"FileBtn_warn__1WN56","fade":"FileBtn_fade__pnb2V"};